/**
 * Issue #21 — 登录短信二次验证 / 恢复码的跨端契约类型。
 *
 * SSOT：直接派生自 apps/api/openapi.yaml → generated/types.ts，**禁止手写契约字段**
 * （与移动端 src/types/auth.ts 同惯例，避免前后端静默漂移）。
 */
import type { components } from './generated/types';

/** 登录第一阶段（202）返回的短信 challenge 摘要（不含任何令牌）。 */
export type SmsChallenge = components['schemas']['SmsChallengeResponse'];

/** 短信校验成功后的会话响应（管理端不会有 trustedDeviceToken）。 */
export type VerifySmsResponse = components['schemas']['VerifySmsResponse'];

/** 超级管理员恢复码应急会话（无 refresh token）。 */
export type RecoverySession = components['schemas']['RecoverySessionResponse'];

/** 令牌对响应（可信设备直发 / 校验通过共用）。 */
export type AuthTokenResponse = components['schemas']['AuthTokenResponse'];

/** 判定一个 /auth/login 结果是「需短信验证」还是「已直发会话」。 */
export function isSmsChallenge(
  result: AuthTokenResponse | SmsChallenge,
): result is SmsChallenge {
  return (
    typeof (result as SmsChallenge).challengeId === 'string' &&
    !(result as AuthTokenResponse).accessToken
  );
}
